import { render, staticRenderFns } from "./gantt-chart.vue?vue&type=template&id=4d2ba032&scoped=true&"
import script from "./gantt-chart.component.ts?vue&type=script&lang=ts&"
export * from "./gantt-chart.component.ts?vue&type=script&lang=ts&"
import style0 from "./gantt-chart.scss?vue&type=style&index=0&id=4d2ba032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ba032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2ba032')) {
      api.createRecord('4d2ba032', component.options)
    } else {
      api.reload('4d2ba032', component.options)
    }
    module.hot.accept("./gantt-chart.vue?vue&type=template&id=4d2ba032&scoped=true&", function () {
      api.rerender('4d2ba032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery/components/gantt-chart/gantt-chart.vue"
export default component.exports